import { Box, styled, Typography } from "@mui/material";
import React, { FC } from "react";
import { Order } from "../../dto/orderSummaryTypes";
import {
  mainContainer,
  spaceBetween,
  textStyle,
  titleStyle,
  orderStyles,
} from "./orderListStyles";

const StyledImage = styled("img")`
  width: 163px;
  object-fit: contain;

  @media (max-width: 600px) {
    width: 67px;
  }
`;

export const OrderListItem: FC<Order> = ({ image, liters, name, quantity }) => (
  <Box sx={mainContainer}>
    <StyledImage src={image ?? ""} alt={name} />
    <Box sx={orderStyles}>
      <Box sx={spaceBetween}>
        <Typography sx={titleStyle}>{name}</Typography>
        <Box>
          <Typography sx={textStyle}>
            Quantity: ({quantity} x {liters}) {quantity * liters} Litres
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>
);
